import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

function missingSupabaseEnv(): string[] {
  const m: string[] = [];
  const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
  const key = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
  if (typeof url !== 'string' || url.trim().length === 0) m.push('VITE_PUBLIC_SUPABASE_URL');
  if (typeof key !== 'string' || key.trim().length === 0) m.push('VITE_PUBLIC_SUPABASE_ANON_KEY');
  return m;
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

const missing = missingSupabaseEnv();

if (missing.length > 0) {
  createRoot(rootEl).render(
    <StrictMode>
      <div
        style={{
          minHeight: '100vh',
          background: '#09090b',
          color: '#fafafa',
          padding: '2rem',
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
          maxWidth: 640,
          margin: '0 auto',
        }}
      >
        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem' }}>
          Configuration required (Vercel)
        </h1>
        <p style={{ color: '#a1a1aa', marginBottom: '1rem', lineHeight: 1.55 }}>
          The app did not receive Supabase environment variables at build time, so it cannot start.
          In Vercel open{' '}
          <strong style={{ color: '#e4e4e7' }}>Project → Settings → Environment Variables</strong>, add
          the variables below for <strong style={{ color: '#e4e4e7' }}>Production</strong> (and Preview
          if needed), then trigger a new deployment.
        </p>
        <ul style={{ margin: '0 0 1rem 1.25rem', fontFamily: 'ui-monospace, monospace', fontSize: '0.875rem' }}>
          {missing.map((k) => (
            <li key={k} style={{ marginBottom: '0.35rem' }}>
              {k}
            </li>
          ))}
        </ul>
        <p style={{ color: '#a1a1aa', fontSize: '0.875rem', marginBottom: '0.75rem' }}>
          Also set{' '}
          <code style={{ color: '#fbbf24' }}>VITE_ECORECYCLE_PREDICT_URL</code> to your Render API URL (no trailing
          slash) so AI classification works in production.
        </p>
        <p style={{ color: '#71717a', fontSize: '0.8rem', lineHeight: 1.5 }}>
          Deploy this repo with <strong style={{ color: '#a1a1aa' }}>Root Directory = frontend</strong> so Vercel runs{' '}
          <code style={{ color: '#fbbf24' }}>vite build</code> from the folder that contains{' '}
          <code style={{ color: '#fbbf24' }}>vercel.json</code>.
        </p>
      </div>
    </StrictMode>,
  );
} else {
  void import('./app-entry').then(({ mountApp }) => mountApp(rootEl));
}
